import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';
import { AuthService } from '../auth/auth.service';
import { MainService } from '../main/main.service';
import { FileCRM, FileRecord, Upload } from './file.model';
import { HttpClient } from '@angular/common/http';
import { MainItem } from 'src/common/services/main/main.model';

import * as firebase from 'firebase/app';
import { SettingService } from '../setting/setting.service';

@Injectable({
  providedIn: 'root'
})
export class GoinfreService extends MainService {

  public refMode = true;



  constructor(
    public auth: AuthService,
    public afs: AngularFirestore,
    public http: HttpClient,
    private _setting: SettingService
  ) {
    super(auth, afs, 'file', 'files', FileCRM);

  }


  pushUpload(upload: Upload, type: string, item: MainItem): Promise<any> {
    return new Promise((resolve, reject) => {  // <-- Added reject
      if (type && !this._typeCheck(upload, type)) {
        return resolve(null);
      }

      const re = /(?:\.([^.]+))?$/;
      const fileExtension = re.exec(upload.file.name)[1]?.toLowerCase(); // <-- Added safe access

      let storageRef = firebase.storage().ref();
      const filename = `${upload.name}-${this._random()}.${fileExtension}`;
      let uploadTask = storageRef.child(`${upload.path}${filename}`).put(upload.file);

      uploadTask.on(
        firebase.storage.TaskEvent.STATE_CHANGED,
        (snapshot) => {
          // Upload in progress
          const snap = snapshot as firebase.storage.UploadTaskSnapshot;
          upload.progress = Math.round((snap.bytesTransferred / snap.totalBytes) * 100);
          upload.setProgress(upload.progress);
        },
        (error) => {
          // Upload failed
          console.log(error);
          reject(error);  // <-- Reject the promise on error
        },
        async () => {
          // Upload success
          try {
            const downloadURL = await uploadTask.snapshot.ref.getDownloadURL();
            const info = {
              url: downloadURL,
              name: filename,
              path: upload.path,
              type: upload.file.type,
            }
            const newFile = new FileCRM(info);

            this._addSynaptoFile({ module: item.module, key: item.values.$key }, newFile);

            await this.saveNewItem(newFile);
            resolve(newFile);  // <-- Ensure Promise resolves correctly
          } catch (err) {
            reject(err);  // <-- Handle errors properly
          }
        }
      );
    });
  }

  protected _random(): string {
    return Math.random().toString(36).slice(2, 11);
  }

  deleteFileUpload(file: FileRecord, item: MainItem): Promise<any> {
    //TODO: do not remove if linked to something else

    if (file.$key) {
      this.deleteFileKey(file.$key);
    }

    const storageRef = firebase.storage().ref();
    return storageRef.child(`${file.path}${file.name}`).delete();
  }

  deleteFileKey(fileKey: string): Promise<any> {
    const batch = firebase.firestore().batch();

    batch.delete(
      firebase.firestore().doc(`/db/modules/files/${fileKey}`)
    );

    return batch.commit();
  }

  public async downloadResource(urlO: string): Promise<Blob> {
    const file = await this.http.get<Blob>(
      urlO,
      { responseType: 'blob' as 'json' }).toPromise();
    return file;
  }

  private _typeCheck(upload: Upload, type: string): boolean {
    return upload.file.type.includes(type);
  }

  async createPDF(template: string, filename: string, oldFile: any, data: any, items: { module: string, key: string }[], open = false): Promise<string> {

    const batch = firebase.firestore().batch();


    // Make sure Firebase is initialized somewhere before this
    const proxyPdfGenerator = firebase.app().functions('us-central1').httpsCallable('proxyPdfGenerator');

    try {
      const response: any = await proxyPdfGenerator({
        templatePath: `${this._setting.FBProject}.appspot.com/template/${template}.zip`,
        outputFileName: `pdf/${filename}.pdf`,
        returnPdfInResponse: false,
        chromiumPdfOptions: { format: 'a4', printBackground: true },
        adjustHeightToFit: false,
        data: data
      });

const result = response.data;

      if (result  && result.done && result.done === 'successful' && result.functionContext?.location
      ) {
        const downloadURL = await firebase.storage().ref().child(result.functionContext?.location).getDownloadURL();

        const info = {
          url: downloadURL,
          name: `${filename}.pdf`,
          path: 'pdf/',
          type: 'application/pdf',
        };

        const file = new FileCRM(info);

        if (oldFile) {
          this.manualSave(file, oldFile.$key, info);
          if (oldFile.name !== info.name) {
            const storageRef = firebase.storage().ref();
            storageRef.child(`${oldFile.path}${oldFile.name}`).delete();
          }
        } else {
          for (const item of items) {
            this._addSynaptoFile(item, file);
          }
          await this.saveNewItem(file);
        }
        if (open) {
          this.openPDF(downloadURL);
        }
        return downloadURL;
      } else {
        throw new Error('Failed to generate PDF: No public URL in response');
      }



    } catch (error) {
      console.error('Error generating PDF:', error);
    }


  }


  public openPDF(url: string) {
    if (url) {
      window.open(url, '_blank');
    }
  }


  private _addSynaptoFile(item: { module: string, key: string }, newFile: FileCRM): void {
    const synap = 'files' + item.module.charAt(0).toUpperCase() + item.module.slice(1);
    if (!newFile.values.synaps) {
      newFile.values.synaps = {};
    }
    newFile.values.synaps[synap] = {};
    newFile.values.synaps[synap][item.key] = true;
  }

}
